import { Component, OnInit } from '@angular/core';
import { SummaryComponent } from '../summary.component';

@Component({
  selector: 'app-summary-desktop',
  templateUrl: './summary-desktop.component.html',
  styleUrls: ['./summary-desktop.component.scss']
})
export class SummaryDesktopComponent extends SummaryComponent implements OnInit {

  ngOnInit(): void {
    super.init();
  }

}
